import { takeLatest, call, put } from 'redux-saga/effects'

import getAccess from 'api/users/Access'
import * as fromActions from '../../actions/user.action'

async function getAccessList() {
  return await getAccess()
}

function* permissionListEffectSaga() {
  try {
    const data = yield call(getAccessList)
    const { admin, moderator, superadmin, supervisor } = data
    const { pathname } = window.location
    const isProtectedUrl =
      pathname.includes('/administration/') ||
      pathname.includes('/configuration/')
    if (isProtectedUrl)
      if (!admin && !superadmin && !supervisor && !moderator) {
        window.location.href = '/'
        return
      }
    yield put(fromActions.Actions.permissions(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* permissionListWatcherSaga() {
  yield takeLatest(fromActions.GET_PERMISSIONS, permissionListEffectSaga)
}
